import styled from 'styled-components';

const StyledKeyLabel = styled.div`
	position: relative;
	padding: 0 5px;
	font-family: 'GT Walsheim Pro';
	font-weight: bold;
	font-size: 12px;
	color: #000;
	transition: color 0.25s ease;
`;

const StyledKeyIcon = styled.div<{
	$src: string;
}>`
	width: 20px;
	height: 20px;
	mask-image: url(${(props) => props.$src});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: 10px 10px;
	-webkit-mask-image: url(${(props) => props.$src});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: 10px 10px;
	background-color: #000;
	transition: background-color 0.25s ease;
`;

const StyledButton = styled.div<{
	$width: number;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: ${(props) => props.$width}px;
	height: 20px;
	border-radius: 6px;
	background-color: #fff;
	transition: background-color 0.25s ease;
`;

export { StyledButton, StyledKeyIcon, StyledKeyLabel };
